// The element the global htmx:afterSettle handler re-initializes (htmx.process,
// Alpine.initTree, __alpineInits).
//
// event.detail.target is the request's swap target. After an outerHTML swap
// that element has been replaced and is detached: Alpine's mutation observer
// already destroyed its tree (clearing _x_marker), so initTree on it would
// re-run every directive on the orphaned nodes with no data stack. Any
// expression naming an x-data property then falls through to window (`open`
// becomes window.open, which Alpine calls: "TypeError: Illegal invocation").
// For a detached target the root is the settled element the event fired on,
// which is the new content.
export function settleRoot(detailTarget: Element | null | undefined, eventTarget: EventTarget | null): Element | null {
    if (detailTarget && detailTarget.isConnected) return detailTarget;
    if (eventTarget && (eventTarget as Element).isConnected) return eventTarget as Element;
    return null;
}
